var iti = document.querySelector("#callcenterphone");
var phoneinput = window.intlTelInput(iti, {
  initialCountry: "CO",
  utilsScript: "https://assets.festivalestereopicnic.com/js/vendor/utils.js",
});

$( document ).ready(function() {
  
  //mobileVerification();
  //$('#liveModal').modal('show')

});

function mobileVerification() {
  if ((navigator.userAgent.indexOf("iPhone") > 0) || (navigator.userAgent.indexOf("iPod") > 0) || (navigator.userAgent.indexOf("iPad") > 0)) {
      var result = confirm("Existe una aplicación iPhone para el FEP X. ¿Te gustaría descargarla?");
      if (result) {
          window.location = "https://itunes.apple.com/co/app/festival-est%C3%A9reo-picnic/id811519318";
      }
  }
  else if (navigator.userAgent.indexOf("Android") > 0) {
      var result = confirm("Existe una aplicación Android para el FEP X. ¿Te gustaría descargarla?");
      if (result) {
          window.location = "https://play.google.com/store/apps/details?id=com.greencopper.android.estereopicnic";
      }
  }
}

$('#myModal').on('hidden.bs.modal', function (e) {
  $("#myModal iframe").attr("src", $("#myModal iframe").attr("src"));
})

$('#togglemenu').click(function(){
  $(this).toggleClass("active");
  $(".blurthis").toggleClass("blur");
  $(".sidemenu").toggleClass("active");
});

$('#closealert').click(function(){
  $("#alerta").addClass("d-none");
});

$('#closecountdown').click(function(){
  $("#countdown").addClass("d-none");
});

var windowHeight = $(window).height();
$("#home").css('min-height',windowHeight);


$(document).on( 'scroll', function(){ 
  if($(window).scrollTop() === 0) {
    $(document.body).removeClass( "fix-frames" );
  } else {
    $(document.body).addClass( "fix-frames" );
  }
});

$('#newsletterform').submit(function(evt){
    
  evt.preventDefault();
  
  $('#newsletterbutton').prop('disabled', true);
  
  var url = $(this).attr('action');

  if(!$("#newsletteremail").val() ){
    !$("#newsletteremail").val()? $("#newsletteremail").focus():null;
    $('#newsletterbutton').prop('disabled', false);
  } else {

    var formData = {
      "campaignToken":"0a7e74be9745b8d76ee6f6206a2e0394",
      "campaignKey": "5710f8e30d99115a71a0b2e5025ca574",
      "email": $("#newsletteremail").val(),
      "tos": true,
      "payload":{
      }
    }


    $.ajax({
      type: "POST",
      data: JSON.stringify(formData),
      dataType: 'json',
      contentType: 'application/json',
      url: url,
      success: function(response){
        if(!response.error){
          $('#newsletterbutton').prop('disabled', false);
          $('#newsletterform')[0].reset();
        } else {
          $('#newsletterbutton').prop('disabled', false);
        }
      }
    });
  }
  
});

$('#mediosform').submit(function(evt){
    
  evt.preventDefault();
  
  $('#mediosbutton').prop('disabled', true);
  
  var url = $(this).attr('action');

  if(!$("#mediosemail").val() ){
    !$("#mediosemail").val()? $("#mediosemail").focus():null;
    $('#mediosbutton').prop('disabled', false);
  } else {

    var formData = {
      "campaignToken":"24e7be602935959c7e711cb12077e2e1",
      "campaignKey": "b634369e112df572ab604afda6ff12b1",
      "email": $("#mediosemail").val(),
      "tos": true,
      "payload":{
        "nombre":$("#mediosnombre").val(),
        "apellido":$("#mediosapellido").val(),
        "celular":$("#medioscelular").val(),
        "medio":$("#mediosmedio").val(),
      }
    }


    $.ajax({
      type: "POST",
      data: JSON.stringify(formData),
      dataType: 'json',
      contentType: 'application/json',
      url: url,
      success: function(response){
        if(!response.error){
          $('#mediosbutton').prop('disabled', false);
          $('#mediosform')[0].reset();
          $("#successmedios").fadeIn();
        } else {
          $('#mediosbutton').prop('disabled', false);
        }
      }
    });
  }
  
});



$('#callcenterform').submit(function(evt){    
  evt.preventDefault();
  
  var extension = phoneinput.getSelectedCountryData().dialCode;
  var number = $("#callcenterphone").val();

  $("#callcenterform").fadeOut(function(){
    callcenter(extension, number);
    $("#thankyoucallcenter").fadeIn();
    $('#callcenterbutton').prop('disabled', false);
  });
  
});

function callcenter(indicativo, numero){

  $('#callcenterbutton').prop('disabled', true);
  var account = '9904419133015298990973ad253a390ae1d3133a';
  var key = '0e78049df4f3ea1b5f1f9faf5cbec4e71bfa1e1b';


  $.ajax({
    type: 'GET',

    // Autenticacion
    beforeSend: function (request) {
      request.setRequestHeader("account", '9904419133015298990973ad253a390ae1d3133a');
      request.setRequestHeader("key", '0e78049df4f3ea1b5f1f9faf5cbec4e71bfa1e1b');
    },

    // Parametros
    data: {
      number: indicativo+numero+'',
      queue: 3
    },

    url: "https://webserv.pbxvirtual.net/api/public/call-me",
    crossDomain: true, 
    dataType: 'json',

    success: function (data) {

      // Imprimir respuesta del API
      $("#callcenterform").fadeOut(function(){
        $("#thankyoucallcenter").fadeIn();
        $('#callcenterbutton').prop('disabled', false);
      });
      console.log(data);
    }
  });
}

/* Countdown */
var deadline = 'Apr 5 2019 12:00:00 GMT-0500';
function time_remaining(endtime){
    var t = Date.parse(endtime) - Date.parse(new Date());
    var seconds = Math.floor( (t/1000) % 60 );
    var minutes = Math.floor( (t/1000/60) % 60 );
    var hours = Math.floor( (t/(1000*60*60)) % 24 );
    var days = Math.floor( t/(1000*60*60*24) );
    return {'total':t, 'days':days, 'hours':hours, 'minutes':minutes, 'seconds':seconds};
}

function run_clock(endtime){

    var days_span = document.getElementById('days');
    var hours_span = document.getElementById('hours');
    var minutes_span = document.getElementById('minutes');
    var seconds_span = document.getElementById('seconds');

    function update_clock(){
        var t = time_remaining(endtime);
        days_span.innerHTML = t.days;
        hours_span.innerHTML = ('0' + t.hours).slice(-2);
        minutes_span.innerHTML = ('0' + t.minutes).slice(-2);
        seconds_span.innerHTML = ('0' + t.seconds).slice(-2);

        if(t.total<=0){ clearInterval(timeinterval); }
    }
    update_clock();
    var timeinterval = setInterval(update_clock,1000);
}

//run_clock(deadline);

(function($) {
  $(document).ready(function() {   
      var windowHeight = $(window).height();
      $(".embajadoresiframe").css('height',windowHeight);
  });

  window.onresize = function(event) {
      var windowHeight = $(window).height();
      $(".embajadoresiframe").css('height',windowHeight);
  };
}(jQuery));